import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4c6b7b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "number-box-input-label" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = {
  class: "textbox-container",
  "data-bind": "dxTextBox: {}"
}

import { PropType, computed, ref } from "vue";
import { DxValidator } from "devextreme-vue";
import { DxButton, DxNumberBox } from "devextreme-vue/number-box";
import { DxRequiredRule, DxCustomRule } from "devextreme-vue/validator";
import { FieldSize } from "@/enums/system/FieldSize";
import { ValidatedEvent } from "devextreme/ui/validator";


export default /*#__PURE__*/_defineComponent({
  __name: 'number-box-field',
  props: {
  /**
   * The maximum length allowed value for the input.
   * @type {number}
   * @default: '50'
   */
  maxLength: {
    type: String,
    default: "50",
  },
  /**
   * The minimum length allowed value for the input.
   * @type {number}
   * @default: '0'
   */
  minLength: {
    type: String,
    default: "0",
  },
  /**
   * The maximum allowed value for the input.
   * @type {number}
   * @default: 1000000
   */
  maxValue: {
    type: Number,
    default: 1000000,
  },
  /**
   * The minimum allowed value for the input.
   * @type {number}
   * @default: 0
   */
  minValue: {
    type: Number,
    default: 0,
  },
  /**
   * The numeric value used with `v-model` to bind the component state. This typically represents an ID or a selected value.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },
  /**
   * The width of the field, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default: FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * A custom validation function for validating the input field.
   * @type {Function}
   */
  customValidation: {
    type: Function,
    required: false,
  },
  /**
   * A second custom validation function for validating the input field.
   * @type {Function}
   */
  secondCustomValidation: {
    type: Function,
    required: false,
  },
  /**
   * A invalid error message to display when validation fails.
   * @type {string}
   * @default ''
   */
  invalidMessage: {
    type: String,
    required: false,
  },
  /**
   * A second invalid error message to display when validation fails.
   * @type {string}
   * @default ''
   */
  secondInvalidMessage: {
    type: String,
    required: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the input control is required.
   * @type {boolean}
   * @default false
   */
  requiredInput: {
    type: Boolean,
    default: false,
  },
  /**
   * The validation group name used for form validation.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    required: false,
    default: "",
  },
  /**
   * The format used for form validation.
   * @type {string}
   * @default ''
   */
  format: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to show the spin button.
   * @type {boolean}
   * @default true
   */
  showSpinButtons: {
    type: Boolean,
    default: true,
  },
  /**
   * The icon associated with the component.
   * @type {string}
   * @default ''
   */
  icon: {
    type: String,
    default: "",
  },
},
  emits: [
  "update:modelValue",
  "valueChanged",
  "onUserInput",
  "iconClicked",
],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "d4ca612e": (props.width)
}))



const value = computed({
  get: () => props.modelValue,
  set: (val: number) => emit("update:modelValue", val),
});



/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
  getValue: () => {
    return value.value;
  },
  applyValidationResults: (e: ValidatedEvent) => {
    isValid.value = !!e.isValid;

    // Construct list of validation errors to be displayed to the user when they hover over the field
    validationErrors.value =
      !e.isValid && e.brokenRule?.message ? e.brokenRule.message : "";
  },
  validationRequestsCallbacks: [],
};

const validationErrors = ref("");
const isValid = ref(true);

const requiredMessage = computed(() =>
  props.label ? `${props.label} is required` : "This field is required",
);

const onUserInput = () => {
  if (String(value.value).length > Number(props.maxLength)) {
    value.value = Number(String(value.value).slice(0, Number(props.maxLength)));
  }

  emit("onUserInput");
};

const onValueChanged = (e: any) => {
  // To prevent v-bind errors due to null values, reset nulls to 0
  if (e.value === null) {
    e.value = 0;
    value.value = 0;
  }

  emit("valueChanged", e.value);
};

// Expose the method validating the field as binding data was nonresponsive and persumably overwritten by DX inbuilts
const setValid = (value: boolean) => {
  isValid.value = value;
};
__expose({ setValid });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DxNumberBox), {
        value: value.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        width: __props.width,
        "read-only": props.readOnly,
        isValid: isValid.value,
        "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => ((isValid).value = $event)),
        hint: validationErrors.value,
        onFocusOut: onUserInput,
        max: props.maxValue,
        min: props.minValue,
        onValueChanged: onValueChanged,
        format: props.format,
        "show-spin-buttons": __props.showSpinButtons
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            name: "first-info-box-icon",
            position: "after",
            options: {
            icon: props.icon,
            stylingMode: 'text',
            type: 'dx-dropdowneditor-button',
            disabled: false,
            visible: props.icon,
            onClick: () => emit('iconClicked'),
          }
          }, null, 8, ["options"]),
          _createVNode(_unref(DxValidator), {
            adapter: adapterConfig,
            "validation-group": props.validationGroup
          }, {
            default: _withCtx(() => [
              (props.requiredInput)
                ? (_openBlock(), _createBlock(_unref(DxRequiredRule), {
                    key: 0,
                    message: requiredMessage.value
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (props.customValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 1,
                    reevaluate: true,
                    "validation-callback": __props.customValidation,
                    message: props.invalidMessage
                  }, null, 8, ["validation-callback", "message"]))
                : _createCommentVNode("", true),
              (props.secondCustomValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 2,
                    reevaluate: true,
                    "validation-callback": __props.secondCustomValidation,
                    message: props.secondInvalidMessage
                  }, null, 8, ["validation-callback", "message"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["validation-group"]),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["value", "width", "read-only", "isValid", "hint", "max", "min", "format", "show-spin-buttons"])
    ])
  ]))
}
}

})